import React, { useEffect, useState } from "react";
import { Table, Checkbox, Modal, Button } from "antd";
import { getNotificationList } from "../../../apis/notificationApi";
import AddNotifications from "./AddNotification";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expoToken, setExpoToken] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (notifications?.length > 0) {
      const filtered = notifications?.filter(
        (notification) =>
          notification.title
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          notification.type?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  }, [searchText, notifications]);

  useEffect(() => {
    fetchNotificationsList();
    setLoading(false);
  }, []);

  const fetchNotificationsList = async () => {
    try {
      const res = await getNotificationList();
      setNotifications(res?.result || []);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setNotifications([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotifications = () => {
    const selectedNotifications = notifications.filter((item) =>
      selectedRowKeys.includes(item.id),
    );
    const tokenList = selectedNotifications
      .map((item) => item.expoToken)
      .join(", ");
    setExpoToken(tokenList);
    setResetKey((prev) => prev + 1);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "Image",
      //   render: (text, record) => <img src={record.image} />,
      render: (text, record) => <img src={record.image} />,
      width: "10%",
    },
    {
      title: "Title",
      dataIndex: "title",
      width: "20%",
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "20%",
    },

    {
      title: "Type",
      dataIndex: "type",
      width: "20%",
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      width: "20%",
      render: (text) => text.split("T")[0],
    },
  ];

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Button
                className="btn btn-primary mb-3"
                onClick={handleSendNotifications}
              >
                Send Notifications
              </Button>
              {/* Search Input */}
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  Enter Search Content
                </label>
                <input
                  type="text"
                  placeholder="Search by title or type"
                  className="form-control w-20"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredList?.length > 0
                      ? filteredList
                      : Array.isArray(notifications) && notifications.length > 0
                        ? notifications
                        : []
                  }
                  rowKey="id"
                  //   loading={loading}
                  //   pagination={{ pageSize: 10 }}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Notifications Modal */}
      <Modal
        title="Send Notifications"
        open={isModalVisible}
        footer={null}
        onCancel={handleModalClose}
        width={600}
      >
        {isModalVisible && (
          <AddNotifications
            expoToken={expoToken}
            onClose={handleModalClose}
            resetKey={resetKey}
          />
        )}
      </Modal>
    </>
  );
};

export default Notifications;
